import { Bar } from "react-chartjs-2";
import CardWrapper from "@/components/CardWrapper";
import { formatPrice, convertCentsToDollars } from "@/lib/utils";
import YearNavigator from "@/components/YearNavigator";
import type { TooltipItem } from "chart.js";

export default function MonthlySalesBarChart({
  salesData,
  colors,
  gridColor,
  selectedYear,
  onYearChange,
  minYear,
}: {
  salesData: { name: string; value: number }[];
  colors: string[];
  gridColor: string;
  selectedYear: number;
  onYearChange: (year: number) => void;
  minYear: number;
}) {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const options = {
    responsive: true,
    interaction: {
      mode: "index" as const,
      intersect: false,
    },
    stacked: false,
    elements: {
      bar: {
        borderRadius: 2,
        inflateAmount: 0.3,
      },
    },
    plugins: {
      legend: { position: "bottom" as const },
      title: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (context: TooltipItem<"bar">) => {
            let label = context.dataset.label || "";

            if (label) {
              label += ": ";
            }
            const value = typeof context.raw === "number" ? context.raw : 0;
            return (label += formatPrice(convertCentsToDollars(value)));
          },
        },
      },
    },
    scales: {
      x: {
        grid: { color: gridColor },
      },
      y: {
        grid: { color: gridColor },
        grace: "10%",
        type: "linear" as const,
        display: true,
        position: "left" as const,
        yAxisId: "y",
        ticks: {
          callback: (value: string | number) =>
            formatPrice(convertCentsToDollars(Number(value))),
        },
      },
    },
  };

  const sourceData = {
    labels: months,
    datasets: [
      {
        label: " Sales",
        data: salesData.map((data) => data.value),
        backgroundColor: colors[0] || ["salmon"],
        borderColor: colors[0] || ["salmon"],
        borderWidth: 1,
        tension: 0.1,
      },
    ],
  };
  return (
    <CardWrapper
      title={
        <YearNavigator
          selectedYear={selectedYear}
          onYearChange={onYearChange}
          minYear={minYear}
          title="Sales"
        />
      }
      content={<Bar data={sourceData} options={options} />}
    />
  );
}
